import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from "./login/login.component";
import {TrackerComponent} from "./tracker/tracker.component";


export const AppRoutes: Routes = [
    { path: 'login',  pathMatch: 'full', component: LoginComponent },
    { path: 'tracker',  pathMatch: 'full', component: TrackerComponent },

    { path: '',   redirectTo: 'home', pathMatch: 'full' },

];

@NgModule({
    imports: [
        RouterModule.forRoot(
            AppRoutes,

        )
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {}
